import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import AccordionDisplay from 'components/blocks/ManagementNewForms/Accordion/AccordionDisplay';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormInputCheckboxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputRadioGroup from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioGroup';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputCuentaBancaria from 'components/blocks/ManagementNewForms/Inputs/FormInputCuentaBancaria';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import FormPrestaciones, { buildPrestacionesSelectionData } from 'components/blocks/ManagementNewForms/Inputs/FormPrestaciones';
import ErrorDisplay from 'components/blocks/ManagementNewForms/ErrorManagement/ErrorPantalla';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import { useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form';
import Loader from 'components/blocks/Loader/Loader';
import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import useCreateSolicitudPrestacionesEspeciales from 'services/record/SolicitudPrestacionesEspeciales/useCreateSolicitudPrestacionesEspeciales';
import useUpdateSolicitudPrestacionesEspecialesByID from 'services/record/SolicitudPrestacionesEspeciales/useUpdateSolicitudPrestacionesEspeciales';
import FormRelacionesLaborales, { normalizeRelacionLaboralBoolean } from 'components/blocks/ManagementNewForms/Inputs/FormRelacionesLaborales';
import { useLocation } from 'react-router-dom';

enum AgrupacionVisualDoc {
    CPE_SolComPrestEsp_Otros = 1,
    CPE_SolComPrestEsp_AyudasOftalmologicasOdontologicas = 2,
    CPE_SolComPrestEsp_ReadaptacionProfesionalBecas = 3,
    CPE_SolComPrestEsp_ReadaptacionViviendasMovilidad = 4,
    CPE_SolComPrestEsp_AdaptacionVehiculosMovilidad = 5,
    CPE_SolComPrestEsp_MovilidadPersonal = 6,
}

const condicionAparicionDocumentacionByTipoAyuda: Record<string, AgrupacionVisualDoc[]> = {
    "1": [AgrupacionVisualDoc.CPE_SolComPrestEsp_ReadaptacionViviendasMovilidad],
    "2": [AgrupacionVisualDoc.CPE_SolComPrestEsp_AyudasOftalmologicasOdontologicas],
    "3": [AgrupacionVisualDoc.CPE_SolComPrestEsp_AyudasOftalmologicasOdontologicas],
    "4": [null],
    "5": [AgrupacionVisualDoc.CPE_SolComPrestEsp_ReadaptacionProfesionalBecas],
    "6": [AgrupacionVisualDoc.CPE_SolComPrestEsp_ReadaptacionProfesionalBecas],
    "7": [AgrupacionVisualDoc.CPE_SolComPrestEsp_MovilidadPersonal, AgrupacionVisualDoc.CPE_SolComPrestEsp_AdaptacionVehiculosMovilidad, AgrupacionVisualDoc.CPE_SolComPrestEsp_ReadaptacionViviendasMovilidad],
    "8": [AgrupacionVisualDoc.CPE_SolComPrestEsp_AdaptacionVehiculosMovilidad],
    "9": [AgrupacionVisualDoc.CPE_SolComPrestEsp_Otros],
};

const getCondicionAparicionDocumentacion = (tipoAyuda: unknown): AgrupacionVisualDoc[] | null => {
    const key = String(tipoAyuda ?? "");
    return condicionAparicionDocumentacionByTipoAyuda[key] ?? null;
};

const SolicitudPrestacionesEspeciales = ({
    info,
    dataUser,
    onSuccess: _onSuccess,
    origen = null,
    expedienteId = null,
}: {
    info: boolean;
    dataUser: any;
    onSuccess?: () => void;
    origen?: string | number | null;
    expedienteId?: string | number | null;
}) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const location = useLocation();
    const origenValue = origen ?? location?.state?.origen ?? null;
    const expedienteIdValue = expedienteId ?? location?.state?.expedienteId ?? null;
    const { createSolicitudPrestacionesEspeciales, dataCreateSolicitudPrestacionesEspeciales, errorCreateSolicitudPrestacionesEspeciales, loadingCreateSolicitudPrestacionesEspeciales, successCreateSolicitudPrestacionesEspeciales } = useCreateSolicitudPrestacionesEspeciales();
    const { dataUpdateSolicitudPrestacionesEspecialesById, errorUpdateSolicitudPrestacionesEspecialesById, loadingUpdateSolicitudPrestacionesEspecialesById, successUpdateSolicitudPrestacionesEspecialesById, updateSolicitudPrestacionesEspecialesById } = useUpdateSolicitudPrestacionesEspecialesByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [prestacionSelectionError, setPrestacionSelectionError] = useState<string | null>(null);
    const [loader, setLoader] = useState(false);
    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;
    const watchSituacionLaboralSolicitanteProvincia = watch('SituacionLaboralSolicitante.ProvinciaCodigo');
    const watchSituacionLaboralSolicitanteProvinciaDescripcion = watch('SituacionLaboralSolicitante.ProvinciaDescripcion');
    const watchTipoAyudaSolicitada = watch('TipoAyudaSolicitada.TipoAyuda');
    const condicionAparicionDocumentacion = getCondicionAparicionDocumentacion(watchTipoAyudaSolicitada);
    const lockExpedienteByOrigenActivo = info === true
        && Number(origenValue) === 1
        && expedienteIdValue !== null
        && expedienteIdValue !== undefined
        && expedienteIdValue !== "";

    const getValue = (...values: any[]) => values.find(value => value !== undefined && value !== null);

    const normalizeIban = (value: any) => {
        if (value === null || value === undefined || value === "") return "";
        return String(value).replace(/-/g, '');
    };

    const formatIbanWithHyphens = (value: any) => {
        const normalizedValue = normalizeIban(value);
        if (!normalizedValue) return null;
        return normalizedValue.replace(/(.{4})(.{4})(.{4})(.{2})/, '$1-$2-$3-$4-');
    };



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {
            const getValue = (...values: any[]) => values.find(v => v !== undefined && v !== null);
            const datosPersonales = getValue(data?.DatosPersonales, data?.datosPersonales) || {};
            const datosSolicitante = getValue(data?.DatosSolicitante, data?.datosSolicitante) || {};
            const datosAccidente = getValue(data?.DatosAccidente, data?.datosAccidente) || {};
            const situacionLaboralTrabajador = getValue(data?.SituacionLaboralTrabajador, data?.situacionLaboralTrabajador) || {};
            const situacionLaboralSolicitante = getValue(data?.SituacionLaboralSolicitante, data?.situacionLaboralSolicitante) || {};
            const situacionEconomica = getValue(data?.SituacionEconomica, data?.situacionEconomica) || {};
            const prestacionesSelectionData = buildPrestacionesSelectionData(data, info);

            if (lockExpedienteByOrigenActivo) {
                const expedienteEncontrado = (prestacionesSelectionData?.options || []).some(
                    (item: any) => String(item?.expedienteId ?? "") === String(expedienteIdValue)
                );

                if (!expedienteEncontrado) {
                    setPrestacionSelectionError(`No se encuentra el ExpedienteId ${String(expedienteIdValue)} entre los Expedientes del Usuario.`);
                    return;
                }
            }

            setPrestacionSelectionError(null);

            const apellidosSolicitante = getValue(datosSolicitante?.Apellidos, datosSolicitante?.apellidos, "");
            const apellidosSolicitanteParts = typeof apellidosSolicitante === 'string'
                ? apellidosSolicitante.trim().split(/\s+/).filter(Boolean)
                : [];

            const situacionFamiliarAccidentado = (getValue(data?.SituacionFamiliarAccidentado, data?.situacionFamiliarAccidentado, []) || [])
                .map((item: any) => ({
                    Id: getValue(item?.Id, item?.id, null),
                    NombreApellidos: getValue(item?.NombreyApellidos, item?.NombreApellidos, item?.nombreyApellidos, item?.nombreApellidos, ""),
                    Edad: getValue(item?.Edad, item?.edad, ""),
                    Parentesco: getValue(item?.Parentesco, item?.parentesco, "")
                }))
                .filter((item: any) => item?.NombreApellidos || item?.Edad || item?.Parentesco);

            const otrosIngresosTabla = (getValue(
                data?.OtrosIngresos,
                data?.otrosIngresos,
                situacionEconomica?.OtrosIngresosTabla,
                situacionEconomica?.otrosIngresosTabla,
                []
            ) || [])
                .map((item: any) => ({
                    Id: getValue(item?.Id, item?.id, null),
                    Concepto: getValue(item?.Concepto, item?.concepto, ""),
                    Empresa: getValue(item?.Empresa, item?.empresa, ""),
                    Cuantia: getValue(item?.Cuantia, item?.cuantia, "")
                }))
                .filter((item: any) => item?.Concepto || item?.Empresa || item?.Cuantia);

            reset({
                DatosPersonales: {
                    SolicitanteNombre: getValue(datosPersonales?.Nombre, datosPersonales?.nombre, ""),
                    SolicitanteApellido1: getValue(datosPersonales?.Apellido1, datosPersonales?.apellido1, ""),
                    SolicitanteApellido2: getValue(datosPersonales?.Apellido2, datosPersonales?.apellido2, ""),
                    SolicitanteIPF: getValue(datosPersonales?.IPF, datosPersonales?.ipf, ""),
                    SolicitanteIPFTipo: getValue(datosPersonales?.IPFTipo, datosPersonales?.ipfTipo)?.toString() || "1",

                    SolicitanteTelefono: getValue(datosPersonales?.Telefono, datosPersonales?.telefono, ""),
                    SolicitanteFijo: getValue(datosPersonales?.Fijo, datosPersonales?.fijo, ""),
                    SolicitanteDomicilio: getValue(datosPersonales?.Domicilio, datosPersonales?.domicilio, ""),
                    SolicitanteCodigoPostal: getValue(datosPersonales?.CodigoPostal, datosPersonales?.codigoPostal, ""),
                    SolicitanteProvincia: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, datosPersonales?.Provincia, datosPersonales?.provincia, ""),
                    SolicitanteProvinciaDescripcion: getValue(datosPersonales?.CodigoProvincia, datosPersonales?.codigoProvincia, datosPersonales?.Provincia, datosPersonales?.provincia, datosPersonales?.ProvinciaDescripcion, datosPersonales?.provinciaDescripcion, ""),
                    SolicitanteComunidadCodigo: getValue(datosPersonales?.ComunidadCodigo, datosPersonales?.CodigoLocalidad, datosPersonales?.codigoLocalidad, ""),
                    SolicitanteComunidadCodigoDescripcion: getValue(datosPersonales?.ComunidadCodigoDescripcion, datosPersonales?.LocalidadDescripcion, datosPersonales?.localidadDescripcion, ""),
                    SolicitanteEmail: getValue(data?.Email, data?.email, ""),
                    SolicitanteFechaNacimiento: getValue(data?.FechaNacimiento, data?.fechaNacimiento, ""),
                    SolicitanteEstadoCivil: getValue(data?.EstadoCivil, data?.estadoCivil, ""),
                    SolicitanteNumeroSS: getValue(datosPersonales?.NumeroSeguridadSocial, datosPersonales?.numeroSeguridadSocial, ""),
                    SolicitanteIRPF: getValue(data?.TipoIRPFVoluntario, data?.tipoIRPFVoluntario, ""),
                },
                DatosSolicitante: {
                    ParentescoAccidentado: getValue(datosSolicitante?.ParentescoConAccidentado, datosSolicitante?.parentescoConAccidentado, datosSolicitante?.ParentescoAccidentado, ""),
                    Nombre: getValue(datosSolicitante?.Nombre, datosSolicitante?.nombre, ""),
                    Apellido1: getValue(datosSolicitante?.Apellido1, datosSolicitante?.apellido1, apellidosSolicitanteParts[0], ""),
                    Apellido2: getValue(datosSolicitante?.Apellido2, datosSolicitante?.apellido2, apellidosSolicitanteParts.slice(1).join(' '), ""),
                    FechaNacimiento: getValue(datosSolicitante?.FechaNacimiento, datosSolicitante?.fechaNacimiento, ""),
                    EstadoCivil: getValue(datosSolicitante?.EstadoCivil, datosSolicitante?.estadoCivil, ""),
                    IPF: getValue(datosSolicitante?.DNI, datosSolicitante?.dni, datosSolicitante?.IPF, datosSolicitante?.ipf, ""),
                    Domicilio: getValue(datosSolicitante?.Domicilio, datosSolicitante?.domicilio, ""),
                    CodigoPostal: getValue(datosSolicitante?.CodigoPostal, datosSolicitante?.codigoPostal, "")
                },
                DatosAccidente: {
                    FechaAccidente: getValue(datosAccidente?.FechaAccidente, datosAccidente?.fechaAccidente, ""),
                    FechaBajaMedica: getValue(datosAccidente?.FechaBajaMedica, datosAccidente?.fechaBajaMedica, ""),
                    FechaAltaMedica: getValue(datosAccidente?.FechaAltaMedica, datosAccidente?.fechaAltaMedica, ""),
                    DescripcionBreve: getValue(datosAccidente?.Descripcion, datosAccidente?.descripcion, datosAccidente?.DescripcionBreve, datosAccidente?.descripcionBreve, ""),
                    Secuelas: getValue(datosAccidente?.TieneSecuelas, datosAccidente?.tieneSecuelas, datosAccidente?.Secuelas, datosAccidente?.secuelas, false),
                    GradoIncapacidad: getValue(datosAccidente?.GradoIncapacidad, datosAccidente?.gradoIncapacidad, ""),
                    FechaResolucion: getValue(datosAccidente?.FechaResolucion, datosAccidente?.fechaResolucion, ""),
                    PrestacionSeleccionada: prestacionesSelectionData?.selectedPrestacionId || "",
                    ExpedienteSeleccionado: prestacionesSelectionData?.selectedExpedienteId ?? null,
                    PrestacionSeleccionadaLabel: prestacionesSelectionData?.selectedLabel || "",
                    PrestacionesCP: prestacionesSelectionData?.options || []
                },
                SituacionNecesidadInvocada: {
                    Descripcion: getValue(
                        data?.SituacionNecesidadInvocadaDescripcion,
                        data?.situacionNecesidadInvocadaDescripcion,
                        data?.SituacionNecesidadInvocada?.Descripcion,
                        data?.situacionNecesidadInvocada?.descripcion,
                        ""
                    )
                },
                SituacionLaboralTrabajador: {
                    EmpresaNombre: getValue(data?.EmpresaNombre, data?.empresaNombre, situacionLaboralTrabajador?.EmpresaNombre, situacionLaboralTrabajador?.empresaNombre, ""),
                    CCCotizacion: getValue(data?.EmpresaCCC, data?.empresaCCC, situacionLaboralTrabajador?.EmpresaCCC, situacionLaboralTrabajador?.empresaCCC, situacionLaboralTrabajador?.CCCotizacion, situacionLaboralTrabajador?.ccCotizacion, ""),
                    NAF: getValue(data?.NAF, data?.naf, data?.EmpresaNAF, data?.empresaNAF, situacionLaboralTrabajador?.NAF, situacionLaboralTrabajador?.naf, ""),
                    CIF: getValue(data?.CIF, data?.cif, data?.EmpresaCIF, data?.empresaCIF, situacionLaboralTrabajador?.CIF, situacionLaboralTrabajador?.cif, ""),
                    EsAutonomo: normalizeRelacionLaboralBoolean(getValue(data?.EsAutonomo, data?.esAutonomo, situacionLaboralTrabajador?.EsAutonomo, situacionLaboralTrabajador?.esAutonomo, null)),
                    ProvinciaCodigo: getValue(
                        data?.EmpresaCodigoProvincia,
                        data?.empresaCodigoProvincia,
                        situacionLaboralTrabajador?.EmpresaCodigoProvincia,
                        situacionLaboralTrabajador?.empresaCodigoProvincia,
                        situacionLaboralTrabajador?.ProvinciaCodigo,
                        situacionLaboralTrabajador?.provinciaCodigo,
                        data?.ProvinciaCodigo,
                        data?.provinciaCodigo,
                        data?.Provincia,
                        data?.provincia,
                        situacionLaboralTrabajador?.Provincia,
                        situacionLaboralTrabajador?.provincia,
                        ""
                    ),
                    ProvinciaDescripcion: getValue(
                        data?.EmpresaProvinciaDescripcion,
                        data?.empresaProvinciaDescripcion,
                        situacionLaboralTrabajador?.EmpresaProvinciaDescripcion,
                        situacionLaboralTrabajador?.empresaProvinciaDescripcion,
                        situacionLaboralTrabajador?.ProvinciaDescripcion,
                        situacionLaboralTrabajador?.provinciaDescripcion,
                        data?.ProvinciaDescripcion,
                        data?.provinciaDescripcion,
                        ""
                    )
                },
                SituacionLaboralSolicitante: {
                    EmpresaNombre: getValue(situacionLaboralSolicitante?.EmpresaNombre, situacionLaboralSolicitante?.empresaNombre, ""),
                    CCCotizacion: getValue(situacionLaboralSolicitante?.EmpresaCCC, situacionLaboralSolicitante?.empresaCCC, situacionLaboralSolicitante?.CCCotizacion, situacionLaboralSolicitante?.ccCotizacion, ""),
                    ProvinciaCodigo: getValue(
                        situacionLaboralSolicitante?.EmpresaCodigoProvincia,
                        situacionLaboralSolicitante?.empresaCodigoProvincia,
                        situacionLaboralSolicitante?.ProvinciaCodigo,
                        situacionLaboralSolicitante?.provinciaCodigo,
                        situacionLaboralSolicitante?.Provincia,
                        situacionLaboralSolicitante?.provincia,
                        ""
                    ),
                    ProvinciaDescripcion: getValue(
                        situacionLaboralSolicitante?.EmpresaProvinciaDescripcion,
                        situacionLaboralSolicitante?.empresaProvinciaDescripcion,
                        situacionLaboralSolicitante?.ProvinciaDescripcion,
                        situacionLaboralSolicitante?.provinciaDescripcion,
                        ""
                    )
                },
                SituacionFamiliarAccidentado: situacionFamiliarAccidentado,
                SituacionEconomica: {
                    SituacionDesempleo: getValue(situacionEconomica?.SituacionDesempleo, situacionEconomica?.situacionDesempleo, false),
                    CobraSubsidioDesempleo: getValue(situacionEconomica?.CobraSubsidioDesempleo, situacionEconomica?.cobraSubsidioDesempleo, false),
                    TieneOtrosIngresos: getValue(situacionEconomica?.TieneOtrosIngresos, situacionEconomica?.TieneOtroIngresos, situacionEconomica?.tieneOtrosIngresos, situacionEconomica?.tieneOtroIngresos, false),
                    TitularCuentaBancaria: (() => {
                        const titularCuenta = getValue(situacionEconomica?.TipoDelAcciSoliBancario, situacionEconomica?.tipoDelAcciSoliBancario, "");
                        return titularCuenta === "" ? "" : titularCuenta?.toString();
                    })(),
                    NumeroCuentaBancaria: normalizeIban(getValue(situacionEconomica?.DatosBancarios_IBAN, situacionEconomica?.datosBancarios_IBAN, situacionEconomica?.NumeroCuentaBancaria, situacionEconomica?.numeroCuentaBancaria, "")),
                    OtrosIngresosTabla: otrosIngresosTabla
                },
                TipoAyudaSolicitada: {
                    TipoAyuda: (() => {
                        const tipoAyudaRoot = typeof data?.TipoAyudaSolicitada === 'number' || typeof data?.TipoAyudaSolicitada === 'string'
                            ? data?.TipoAyudaSolicitada
                            : undefined;
                        const tipoAyudaRootLegacy = typeof data?.tipoAyudaSolicitada === 'number' || typeof data?.tipoAyudaSolicitada === 'string'
                            ? data?.tipoAyudaSolicitada
                            : undefined;
                        const tipoAyuda = getValue(
                            data?.TipoAyudaSolicitada?.TipoAyuda,
                            data?.tipoAyudaSolicitada?.tipoAyuda,
                            tipoAyudaRoot,
                            tipoAyudaRootLegacy,
                            ""
                        );
                        return tipoAyuda === "" ? "" : tipoAyuda?.toString();
                    })(),
                    IndicarAyuda: getValue(
                        data?.TipoAyudaSolicitada?.IndicarAyuda,
                        data?.tipoAyudaSolicitada?.indicarAyuda,
                        data?.TipoAyudaSolicitadaDescripcion,
                        data?.tipoAyudaSolicitadaDescripcion,
                        ""
                    )
                },
                Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion),
            })
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        if (prestacionSelectionError) {
            setLoader(false);
            return;
        }

        const normalizeNullableValue = (value: any) => {
            if (value === null || value === undefined || value === "") return null;
            return value;
        };

        const parseNullableInt = (value: any) => {
            if (value === null || value === undefined || value === "") return null;
            const parsed = Number(value);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const parseExpedienteId = (value: any) => {
            const normalized = normalizeNullableValue(value);
            if (normalized === null) return null;

            const parsed = Number(normalized);
            return Number.isNaN(parsed) ? normalized : parsed;
        };

        const prestacionIdSeleccionada = normalizeNullableValue(data?.DatosAccidente?.PrestacionSeleccionada)
            ?? normalizeNullableValue(dataUser?.PrestacionId);
        const expedienteIdSeleccionado = parseExpedienteId(data?.DatosAccidente?.ExpedienteSeleccionado)
            ?? parseExpedienteId(dataUser?.ExpedienteId);

        const parseNumberOrZero = (value: any) => {
            if (value === null || value === undefined || value === "") return 0;
            const normalizedValue = typeof value === 'string' ? value.replace(',', '.') : value;
            const parsed = Number(normalizedValue);
            return Number.isNaN(parsed) ? 0 : parsed;
        };

        const buildApellidos = (...values: any[]) => values
            .filter(value => value !== undefined && value !== null && value !== '')
            .join(' ')
            .trim();
        const esAutonomo = normalizeRelacionLaboralBoolean(data?.SituacionLaboralTrabajador?.EsAutonomo);

        const situacionFamiliarAccidentado = (data?.SituacionFamiliarAccidentado || [])
            .map((item: any) => ({
                id: item?.Id ?? item?.id ?? null,
                nombreyApellidos: item?.NombreApellidos || '',
                edad: parseNumberOrZero(item?.Edad),
                parentesco: item?.Parentesco || ''
            }))
            .filter((item: any) => item?.nombreyApellidos || item?.edad > 0 || item?.parentesco);

        const otrosIngresos = (data?.SituacionEconomica?.OtrosIngresosTabla || [])
            .map((item: any) => ({
                id: item?.Id ?? item?.id ?? null,
                concepto: item?.Concepto || '',
                empresa: item?.Empresa || '',
                cuantia: parseNumberOrZero(item?.Cuantia)
            }))
            .filter((item: any) => item?.concepto || item?.empresa || item?.cuantia > 0);

        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: expedienteIdSeleccionado ?? 0,
            PrestacionId: prestacionIdSeleccionada,

            Acepto: data?.Acepto ?? false,
            impersonadorId: dataUser?.ImpersonadorId || 0,

            // -----------------------------------
            // DATOS PERSONALES
            // -----------------------------------
            datosPersonales: {
                nombre: data?.DatosPersonales?.SolicitanteNombre || "",
                apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
                apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
                ipf: data?.DatosPersonales?.SolicitanteIPF || "",
                ipfTipo: parseNullableInt(data?.DatosPersonales?.SolicitanteIPFTipo) ?? 1,
                telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
                fijo: data?.DatosPersonales?.SolicitanteFijo || "",
                domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
                codigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
                provinciaDescripcion: data?.DatosPersonales?.SolicitanteProvincia || data?.DatosPersonales?.SolicitanteProvinciaDescripcion || "",
                codigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || "",
                codigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || "",
                localidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || "",
                numeroSeguridadSocial: data?.DatosPersonales?.SolicitanteNumeroSS || data?.DatosPersonales?.SolicitanteSeguridadSocial || "",
            },

            fechaNacimiento: data?.DatosPersonales?.SolicitanteFechaNacimiento || null,
            estadoCivil: data?.DatosPersonales?.SolicitanteEstadoCivil || "",

            datosSolicitante: {
                parentescoConAccidentado: data?.DatosSolicitante?.ParentescoAccidentado || "",
                nombre: data?.DatosSolicitante?.Nombre || "",
                apellidos: buildApellidos(data?.DatosSolicitante?.Apellido1, data?.DatosSolicitante?.Apellido2),
                fechaNacimiento: data?.DatosSolicitante?.FechaNacimiento || null,
                estadoCivil: data?.DatosSolicitante?.EstadoCivil || "",
                dni: data?.DatosSolicitante?.IPF || "",
                domicilio: data?.DatosSolicitante?.Domicilio || "",
                codigoPostal: data?.DatosSolicitante?.CodigoPostal || ""
            },

            datosAccidente: {
                fechaAccidente: data?.DatosAccidente?.FechaAccidente || null,
                fechaBajaMedica: data?.DatosAccidente?.FechaBajaMedica || null,
                fechaAltaMedica: data?.DatosAccidente?.FechaAltaMedica || null,
                descripcion: data?.DatosAccidente?.DescripcionBreve || "",
                tieneSecuelas: data?.DatosAccidente?.Secuelas ?? false,
                gradoIncapacidad: data?.DatosAccidente?.GradoIncapacidad || "",
                fechaResolucion: data?.DatosAccidente?.FechaResolucion || null
            },

            situacionNecesidadInvocadaDescripcion: data?.SituacionNecesidadInvocada?.Descripcion || "",

            empresaNombre: data?.SituacionLaboralTrabajador?.EmpresaNombre || "",
            empresaCCC: esAutonomo === true ? null : data?.SituacionLaboralTrabajador?.CCCotizacion || "",
            EmpresaNombre: data?.SituacionLaboralTrabajador?.EmpresaNombre || "",
            EmpresaCCC: esAutonomo === true ? null : data?.SituacionLaboralTrabajador?.CCCotizacion ?? null,
            CIF: esAutonomo === true ? null : data?.SituacionLaboralTrabajador?.CIF ?? null,
            NAF: esAutonomo === false ? null : data?.SituacionLaboralTrabajador?.NAF ?? null,
            EsAutonomo: esAutonomo,
            empresaCodigoProvincia: data?.SituacionLaboralTrabajador?.ProvinciaCodigo || "",
            empresaProvinciaDescripcion: data?.SituacionLaboralTrabajador?.ProvinciaDescripcion || "",

            situacionLaboralSolicitante: {
                empresaNombre: data?.SituacionLaboralSolicitante?.EmpresaNombre || "",
                empresaCCC: data?.SituacionLaboralSolicitante?.CCCotizacion || "",
                empresaCodigoProvincia: data?.SituacionLaboralSolicitante?.ProvinciaCodigo || "",
                empresaProvinciaDescripcion: data?.SituacionLaboralSolicitante?.ProvinciaDescripcion || ""
            },

            situacionFamiliarAccidentado,

            situacionEconomica: {
                tieneOtroIngresos: data?.SituacionEconomica?.TieneOtrosIngresos ?? false,
                situacionDesempleo: data?.SituacionEconomica?.SituacionDesempleo ?? false,
                cobraSubsidioDesempleo: data?.SituacionEconomica?.CobraSubsidioDesempleo ?? false,
                tipoDelAcciSoliBancario: parseNullableInt(data?.SituacionEconomica?.TitularCuentaBancaria) ?? 0,
                datosBancarios_IBAN: formatIbanWithHyphens(data?.SituacionEconomica?.NumeroCuentaBancaria)
            },

            otrosIngresos,

            tipoAyudaSolicitada: parseNullableInt(data?.TipoAyudaSolicitada?.TipoAyuda) ?? 0,
            Documentacion: await prepareDocumentacionArrayWithCase(data?.Documentacion || []),
        }

        const userId = String(dataUser?.UsuarioId ?? dataUser?.Id ?? '');
        const formId = String(dataUser?.Id ?? '');

        if (info) {
            await createSolicitudPrestacionesEspeciales(userId, datosEnvio, _onSuccess);
            setBloquearEnvio(true);
        } else {
            await updateSolicitudPrestacionesEspecialesById(userId, formId, datosEnvio, _onSuccess);
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return prestacionSelectionError ? (
        <ErrorDisplay descripcionError={prestacionSelectionError} />
    ) : (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={getValue(datosAPI?.EstadoFormulario, datosAPI?.estadoFormulario, dataUser?.EstadoFormulario, dataUser?.estadoFormulario)}
                    estadoFormularioDescripcion={getValue(datosAPI?.EstadoFormularioDescripcion, datosAPI?.estadoFormularioDescripcion, dataUser?.EstadoFormularioDescripcion, dataUser?.estadoFormularioDescripcion)}
                    fechaActualizacionEstado={getValue(datosAPI?.FechaActualizacionEstado, datosAPI?.fechaActualizacionEstado, dataUser?.FechaActualizacionEstado, dataUser?.fechaActualizacionEstado)}
                />

                <Loader activeLoader={loader || loadingCreateSolicitudPrestacionesEspeciales || loadingUpdateSolicitudPrestacionesEspecialesById} label="Cargando Formulario"></Loader>








                {/* //////////////////////////// COMIENZO FORMULARIO //////////////////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}

                <FormDatosPersonales title={'Datos del Accidentado'} activarEstadoCivil={true} activarFechaNacimiento={true} >

                </FormDatosPersonales>

                <AccordionForm title={'Datos del Solicitante'} expandedInit={false} nombreError='DatosSolicitante' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="(rellenar solo si es persona distinta del Accidentado)" disabled={false}>

                                <FormInputText
                                    name='DatosSolicitante.ParentescoAccidentado'
                                    id='DatosSolicitante.ParentescoAccidentado'
                                    label='Parentesco con el accidentado'
                                    md={12}
                                    xl={12}
                                />

                                <FormInputText
                                    name='DatosSolicitante.Nombre'
                                    id='DatosSolicitante.Nombre'
                                    label='Nombre'
                                    md={4}
                                    xl={4}
                                />
                                <FormInputText
                                    name='DatosSolicitante.Apellido1'
                                    id='DatosSolicitante.Apellido1'
                                    label='Apellido 1'
                                    md={4}
                                    xl={4}
                                />
                                <FormInputText
                                    name='DatosSolicitante.Apellido2'
                                    id='DatosSolicitante.Apellido2'
                                    label='Apellido 2'
                                    md={4}
                                    xl={4}
                                />

                                <FormInputFecha
                                    name={'DatosSolicitante.FechaNacimiento'}
                                    id={'DatosSolicitante.FechaNacimiento'}
                                    label={'Fecha de Nacimiento'}
                                    md={4}
                                    xl={4}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                />

                                <FormInputText
                                    name='DatosSolicitante.EstadoCivil'
                                    id='DatosSolicitante.EstadoCivil'
                                    label='Estado Civil'
                                    md={4}
                                    xl={4}
                                />

                                <FormInputIPF
                                    name={'DatosSolicitante.IPF'}
                                    id={'DatosSolicitante.IPF'}
                                    label={'DNI/NIF'}
                                    placeholder={''}
                                    md={4}
                                    xl={4}
                                    disabled={false}
                                />

                                <FormInputText
                                    name='DatosSolicitante.Domicilio'
                                    id='DatosSolicitante.Domicilio'
                                    label='Domicilio'
                                    md={8}
                                    xl={8}
                                />

                                <FormInputText
                                    name='DatosSolicitante.CodigoPostal'
                                    id='DatosSolicitante.CodigoPostal'
                                    label='Código Postal'
                                    md={4}
                                    xl={4}
                                    pattern={/^\d{5}$/}
                                    patternMessage='Debe introducir un código postal válido de 5 dígitos'
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Datos del Accidente'} expandedInit={false} nombreError='DatosAccidente' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputFecha
                                    name={'DatosAccidente.FechaAccidente'}
                                    id={'DatosAccidente.FechaAccidente'}
                                    label={'Fecha de Accidente'}
                                    md={4}
                                    xl={4}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                    req='La fecha del accidente es obligatoria'
                                />

                                <FormInputFecha
                                    name={'DatosAccidente.FechaBajaMedica'}
                                    id={'DatosAccidente.FechaBajaMedica'}
                                    label={'Fecha de Baja Médica'}
                                    md={4}
                                    xl={4}
                                    col={12}
                                    maxDate={new Date(Date.now())}
                                />

                                <FormInputFecha
                                    name={'DatosAccidente.FechaAltaMedica'}
                                    id={'DatosAccidente.FechaAltaMedica'}
                                    label={'Fecha de Alta Médica'}
                                    modal={'Si está ya de alta médica'}
                                    md={4}
                                    xl={4}
                                    col={12}
                                />

                                <FormInputText
                                    name='DatosAccidente.DescripcionBreve'
                                    id='DatosAccidente.DescripcionBreve'
                                    label='Breve descripción del accidente'
                                    md={12}
                                    xl={12}
                                />

                                <FormInputCheckboxTable
                                    labels={['Secuelas']}
                                    names={['DatosAccidente.Secuelas']}
                                    col={12}
                                />

                                <FormInputText
                                    name='DatosAccidente.GradoIncapacidad'
                                    id='DatosAccidente.GradoIncapacidad'
                                    label='Grado de Incapacidad'
                                    modal='Reconocido por el INSS'
                                    md={4}
                                    xl={4}
                                />

                                <FormInputFecha
                                    name={'DatosAccidente.FechaResolucion'}
                                    id={'DatosAccidente.FechaResolucion'}
                                    label={'Fecha de Resolución'}
                                    md={4}
                                    xl={4}
                                    col={12}
                                />

                                <FormPrestaciones
                                    info={info}
                                    baseName='DatosAccidente'
                                    origen={origenValue}
                                    expedienteId={expedienteIdValue}
                                    label='Prestación relacionada'
                                    required='Debe seleccionar una prestación'
                                    md={4}
                                    xl={4}
                                    col={12}
                                    onErrorChange={setPrestacionSelectionError}
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Situacion de Necesidad invocada'} expandedInit={false} nombreError='SituacionNecesidadInvocada' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>

                                <div className="col-xl-12 col-md-12">
                                    <TextAreaDefault
                                        id='SituacionNecesidadInvocada.Descripcion'
                                        name='SituacionNecesidadInvocada.Descripcion'
                                        label=''
                                        placeholder=''
                                        rows={5}
                                    />
                                </div>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>



                <AccordionForm title={'Situación laboral del trabajador'} expandedInit={false} nombreError='SituacionLaboralTrabajador' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="(En el momento del accidente)" disabled={false}>

                                <FormRelacionesLaborales
                                    info={info}
                                    names={{
                                        nombreEmpresa: 'SituacionLaboralTrabajador.EmpresaNombre',
                                        ccc: 'SituacionLaboralTrabajador.CCCotizacion',
                                        naf: 'SituacionLaboralTrabajador.NAF',
                                        cif: 'SituacionLaboralTrabajador.CIF',
                                        esAutonomo: 'SituacionLaboralTrabajador.EsAutonomo',
                                        provinciaCodigo: 'SituacionLaboralTrabajador.ProvinciaCodigo',
                                        provinciaDescripcion: 'SituacionLaboralTrabajador.ProvinciaDescripcion',
                                    }}
                                    labels={{
                                        selector: 'Entorno laboral',
                                        nombreEmpresa: 'Nombre de la Empresa',
                                        ccc: 'C.C.Cotización',
                                        naf: 'NAF',
                                        cif: 'CIF',
                                    }}
                                    selectorName='SituacionLaboralTrabajador.RelacionLaboralId'
                                    relacionesLaborales={datosAPI?.RelacionLaboral ?? datosAPI?.relacionLaboral ?? []}
                                    showProvince={true}
                                    md={6}
                                    xl={6}
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Situación laboral del solicitante'} expandedInit={false} nombreError='SituacionLaboralSolicitante' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="(rellenar solo si es persona distinta del Accidentado)" disabled={false}>

                                <FormInputText
                                    name='SituacionLaboralSolicitante.EmpresaNombre'
                                    id='SituacionLaboralSolicitante.EmpresaNombre'
                                    label='Nombre de la Empresa'
                                    md={6}
                                    xl={6}
                                />

                                <FormInputText
                                    name='SituacionLaboralSolicitante.CCCotizacion'
                                    id='SituacionLaboralSolicitante.CCCotizacion'
                                    label='C.C.Cotización'
                                    md={6}
                                    xl={6}
                                    pattern={/^\d{11}$/}
                                    maxLength={11}
                                    patternMessage='Debe introducir 11 números'
                                />

                                <div className="col-xl-12 col-md-12">
                                    <Province
                                        errors={errors}
                                        register={register}
                                        idCode={'SituacionLaboralSolicitante.ProvinciaCodigo'}
                                        watchProvinceDescription={watchSituacionLaboralSolicitanteProvinciaDescripcion}
                                        idDescription={'SituacionLaboralSolicitante.ProvinciaDescripcion'}
                                        watchProvinceCode={watchSituacionLaboralSolicitanteProvincia}
                                        setValue={setValue}
                                        disabled={false}
                                    />
                                </div>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Situación familiar del accidentado'} expandedInit={false} nombreError='SituacionFamiliarAccidentado' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="(cumplimentar si el trabajador tiene cónyuge y/o hijos que convivan con él)" disabled={false}>

                                <FormInputTable
                                    name="SituacionFamiliarAccidentado"
                                    heads={["Nombre y Apellidos", "Edad", "Parentesco"]}
                                    nameHeads={["NombreApellidos", "Edad", "Parentesco"]}
                                    widthColumn={[6, 2, 4]}
                                    inputType={[1, 10, 1]}
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Situación económica'} expandedInit={false} nombreError='SituacionEconomica' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputCheckboxTable
                                    labels={[
                                        'Situación de Desempleo',
                                        'Cobra Subsidio desempleo',
                                        'Tiene otros Ingresos'
                                    ]}
                                    names={[
                                        'SituacionEconomica.SituacionDesempleo',
                                        'SituacionEconomica.CobraSubsidioDesempleo',
                                        'SituacionEconomica.TieneOtrosIngresos'
                                    ]}

                                    col={12}
                                />

                                <AccordionDisplay
                                    dataUser={dataUser}
                                    visibility={watch('SituacionEconomica.TieneOtrosIngresos') === true}
                                    autoComplete={false}
                                    fields={['SituacionEconomica.OtrosIngresosTabla']}
                                >
                                    <p>En caso de tener otros ingresos indicar cuales</p>
                                    <FormInputTable
                                        name="SituacionEconomica.OtrosIngresosTabla"
                                        heads={["Concepto", "Empresa", "Cuantía"]}
                                        nameHeads={["Concepto", "Empresa", "Cuantia"]}
                                        widthColumn={[4, 4, 4]}
                                        inputType={[1, 1, 3]}
                                    />
                                </AccordionDisplay>
                                <div className="m-3"></div>
                                <FormInputRadioGroup
                                    title="Titular de la cuenta bancaria"
                                    name="SituacionEconomica.TitularCuentaBancaria"
                                    labels={['Del Accidentado', 'Del Solicitante']}
                                    values={[0, 2]}
                                    col={12}
                                    required='Debe indicar el titular de la cuenta bancaria'
                                />

                                <FormInputCuentaBancaria
                                    id='SituacionEconomica.NumeroCuentaBancaria'
                                    name='SituacionEconomica.NumeroCuentaBancaria'
                                    xl={12}
                                    md={12}
                                    placeholder=''
                                    req='Falta el Número de Cuenta Bancaria'
                                />

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>



                <AccordionForm title={'Tipo de ayuda solicitada'} expandedInit={false} nombreError='TipoAyudaSolicitada' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>

                                <FormInputRadioGroup
                                    title=""
                                    name="TipoAyudaSolicitada.TipoAyuda"
                                    labels={[
                                        'Readaptación de Viviendas',
                                        'Ayudas Oftalmológicas',
                                        'Ayudas Odontológicas',
                                        'Tratamiento Psicológico a familiares',
                                        'Readaptación Profesional',
                                        'Becas de Estudio (accidentado)',
                                        'Movilidad Personal',
                                        'Adaptación de Vehiculos',
                                        'Otros.'
                                    ]}
                                    values={[1,2,3,4,5,6,7,8,9]}
                                    required='Debe indicar la ayuda solicitada'
                                    col={6}
                                />

                                <AccordionDisplay
                                    dataUser={dataUser}
                                    visibility={watchTipoAyudaSolicitada === '8'}
                                    fields={['TipoAyudaSolicitada.IndicarAyuda']}
                                >
                                    <FormInputText
                                        name='TipoAyudaSolicitada.IndicarAyuda'
                                        id='TipoAyudaSolicitada.IndicarAyuda'
                                        label='Indicar en que consiste la ayuda'
                                        md={12}
                                        xl={12}
                                    />
                                </AccordionDisplay>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FormArrayArchivosReducidos
                                name={'Documentacion'}
                                urlArchivos={dataUser?.Documentacion?.map(d => d?.SasUri) || []}
                                setTotalSize={setTotalSize}
                                CondicionAparicionDocumentacion={condicionAparicionDocumentacion}
                            />

                        </div>
                    </div>
                </AccordionForm>












                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio || !!prestacionSelectionError}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateSolicitudPrestacionesEspeciales}
                    successUpdate={successUpdateSolicitudPrestacionesEspecialesById}
                    errorCreate={errorCreateSolicitudPrestacionesEspeciales}
                    errorUpdate={errorUpdateSolicitudPrestacionesEspecialesById}
                    datosAPI={datosAPI}
                    totalSizeDocs={totalSize}
                    info={info}
                    MaxSizeMB={MAX_SIZE_MB}
                />


                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p className='text-info-legal paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default SolicitudPrestacionesEspeciales
